import { gql } from 'src/generated/gql';

export const WAITLIST_PROMOTE_MUTATION = gql(`
  mutation WaitlistPromote($count: Int!, $payorId: String) {
    staff_waitlistPromote(count: $count, payorId: $payorId)
  }
`);
